import React from 'react'
import { Breadcrumb, BreadcrumbProps } from 'semantic-ui-react'
import { pathStepBack } from '../../utils/helpers'
import { observer, useStore, } from '../../stores'

export interface BreadCrumbsProps {
  clickable?: boolean
  size: 'large' | 'huge'
}

const BreadCrumbs = observer((props: BreadcrumbProps) => {
    const { size, clickable = true } = props
    const { fileStore: {path, changePath} } = useStore()
    const isRoot = !path.length

    return (
      <>
        <Breadcrumb size={size}>
          <Breadcrumb.Section
            onClick={() => clickable && !isRoot && changePath('')}
            link={false}
            active={true}
          >
            home
          </Breadcrumb.Section>
          <Breadcrumb.Divider>
            <b>/</b>
          </Breadcrumb.Divider>

          {path.map((folder, i) => {
            const isLast = i === path.length - 1
            return (
              <React.Fragment key={i}>
                {!isLast || !clickable ? (
                  <Breadcrumb.Section
                    link
                    onClick={() =>
                      clickable && !isRoot && changePath(pathStepBack(path))
                    }
                  >
                    {folder}
                  </Breadcrumb.Section>
                ) : (
                  <Breadcrumb.Section active>{folder}</Breadcrumb.Section>
                )}

                <Breadcrumb.Divider>
                  <b>/</b>
                </Breadcrumb.Divider>
              </React.Fragment>
            )
          })}
        </Breadcrumb>
      </>
    )
})

export default BreadCrumbs
